import styled from 'styled-components'

const Section = styled.section`
  max-width: 1500px;
  align-self: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export default Section